// extracted by css-extract-rspack-plugin
export default {"cls1":"CreateSocialItem-cls1_Oj5","cls2":"CreateSocialItem-cls2_NCh CreateSocialItem-cls1_Oj5"};